import {createStore, combineReducers, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'

import userReducer from './UsersDucks'
import messageReducer from './MessageDucks'
import flowReducer from './FlowDucks'
import businessReducer from './BusinessDucks'
import conversationReducer from './ConversationDucks'
import integrationReducer from './IntegrationDucks'
import GPTServiceReducer from './GPTServiceDucks'
import CampaignReducer from './CampaignDucks'
import TemplateReducer from './TemplateDucks'
import AccountReducer from './AccountDucks'
import notificacionesReducer from './NotificacionesDucks'
import waitingQueueReducer from './WaitingQueueDucks'
import supervisionReducer from './SupervisionDucks'
import informesAIReducer from './InformesAIDucks'
import subscriptionPlansReducer from './SubscriptionPlansDucks'
import tokenPackagesReducer from './TokenPackagesDucks'
import commissionConfigReducer from './CommissionConfigDucks'

const rootReducer = combineReducers({
    users : userReducer,
    message : messageReducer,
    flow : flowReducer,
    business: businessReducer,
    conversation: conversationReducer,
    report: integrationReducer,
    gptService: GPTServiceReducer,
    campaign: CampaignReducer,
    template: TemplateReducer,
    account: AccountReducer,
    notificaciones: notificacionesReducer,
    waitingQueue: waitingQueueReducer,
    supervision: supervisionReducer,
    informesAI: informesAIReducer,
    subscriptionPlans: subscriptionPlansReducer,
    tokenPackages: tokenPackagesReducer,
    commissionConfig: commissionConfigReducer,

})

export default function generateStore() {
    const store = createStore( rootReducer, composeWithDevTools( applyMiddleware(thunk) ) )
    return store
}